import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSection = styled.div`
    display: flex;
    margin-bottom: 20px;
`;

const Section = (props) => {
    const { children } = props;

    return (
        <StyledSection>
            { children }
        </StyledSection>
    );
};

Section.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/ui/general/Section.js